import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-pink-100 bg-white px-4 py-12" data-id="element-153" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-154" data-mp="32nun0sijob3h">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-155" data-mp="32pfeuadh5fxn">
          🏃‍♀️ Combo Completo Jumping 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-156" data-mp="3uf0phflqmkvx">
          El sistema de enseñanza para instructores de Jumping de todos los niveles en Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-157" data-mp="387fbm8yvbf9">
          Porque enseñar jumping no debería costarte todos los domingos del año.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-158" data-mp="3qcx9cdo4is4b">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-159" data-mp="29xm0kogz74j3">
            <MailIcon className="h-4 w-4" data-id="element-160" data-mp="3la2a6wqof7wa" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-161" data-mp="3gbimaqsivm1a">
            <GlobeIcon className="h-4 w-4" data-id="element-162" data-mp="830j3ija450h" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-163" data-mp="80xmgfnmfdms">
            <InstagramIcon className="h-4 w-4" data-id="element-164" data-mp="cv1pwoxoh3j4" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-pink-100 pt-6" data-id="element-165" data-mp="qujilfe3h0xr">
          <p className="text-base font-black text-ink" data-id="element-166" data-mp="ms6gd0yk3l5q">
            🏃‍♀️ “El próximo domingo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-167" data-mp="tw5yi6q9bqmq">
            “¡Finalmente un domingo sin Jumping!”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-168" data-mp="ys3egbxlyuyz">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-169" data-mp="18jr3652s5xwr" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}